import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const territorySlice = createSlice({
  name: "territory",
  initialState: {
    territoryItems: [],
    territory: {},
    loading: false,
    error: null,
  },
  reducers: {
    setTerritoryItems: (state, action) => {
      state.territoryItems = action.payload.data || [];
      state.loading = false;
    },
    setTerritory: (state, action) => {
      state.territory = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectTerritoryLoading = (state) => state.territory.loading;
export const selectTerritoryError = (state) => state.territory.error;
export const selectTerritoryItems = (state) => state.territory.territoryItems;
export const selectTerritory = (state) => state.territory.territory;

// Export the reducer to include in the store
export const { setTerritory, setTerritoryItems } = territorySlice.actions;
export default territorySlice.reducer;
